export default __webpack_public_path__ + "img/petersons-PLUSLogo-01.png";